/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'

import { range } from '~bookwormgb/util/range'

class SingleproductCarouselPlaceholder extends Component {

	render() {
		const {
			limit = 1,
			placeholder = 0,
			showImage = true,
			showProductFormat = true,
			showProductTitle = true,
			showProductAuthor = true,
			showProductPrice = true,
			showAddToCart = true,
			showCompare = true,
			showWishlist = true,
			enableContainer= true,
		} = this.props

		const output = (
			<div className="bwgb-single-product-carousel bwgb-single-product-carousel-placeholder">
				<div className={ classnames( [ 'wp-block-bwgb-single-product-carousel__inner' ], { 'container' : enableContainer } ) }>

					{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
						return(
							<div className="product space-top-lg-2 space-bottom-lg-4 position-relative" key={ `product-${i}` }>
								<div className="media justify-content-center align-items-center">
									<div className="woocommerce-loop-product__thumbnail mb-6 mb-md-10 mb-lg-0">
										{ showImage &&
											<div className="progress bg-light mb-2" style={ { width:'300px', height:'300px' } }></div>
										}
									</div>
									<div className="media-body ml-md-5 ml-lg-10 max-width-410">
										{ showProductFormat &&
											<div className="badge badge-shadow w-50">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductTitle &&
											<div className="badge badge-shadow w-80">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductAuthor &&
											<div className="badge badge-shadow w-50 d-block">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductPrice &&
											<div className="badge badge-shadow w-50 mb-4">
												<div className="progress bg-light"></div>
											</div>
										}

										{ ( showAddToCart || showCompare || showWishlist ) &&
											<div className="d-flex">
												{ showAddToCart && 
													<div className="badge badge-shadow w-25">
														<div className="progress bg-light"></div>
													</div>
												}

												{ showCompare && 
													<div className="ml-2 badge badge-shadow w-20">
														<div className="progress bg-light"></div>
													</div>
												}

												{ showWishlist && 
													<div className="ml-2 badge badge-shadow w-20">
														<div className="progress bg-light"></div>
													</div>
												}

											</div>
										}
									</div>	
								</div>
							</div>
						)
					} ) }
				</div>
			</div>
		)

		return output
	}
}

export default SingleproductCarouselPlaceholder